// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2MtMn","col":"styles_col__9G__u"};